<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      ><el-row :gutter="20">
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_category') || '素材分类'"
            prop="deCategoryCode"
          >
            <dict-select
              v-model="formData.deCategoryCode"
              disabled
              style="width: 100%"
              size="medium"
              url="/digitalCenter/common/dict/elementCategorySelect"
              filterable
              clearable
              :placeholder="$l('form_label_category') || '素材分类'"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_is_visiable') || '是否显示'"
            prop="isVisible"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              disabled
              v-model="formData.isVisible"
            >
              <el-radio label="Y">{{ $l("form_radio_yes") || "是" }}</el-radio>
              <el-radio label="N">{{ $l("form_radio_no") || "否" }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_column_name') || '字段名称'"
            prop="inputColumnDisplay"
          >
            <el-input
              v-model="formData.inputColumnDisplay"
              maxlength="50"
              :disabled="disabled"
              clearable
              size="medium"
              :placeholder="$l('form_label_column_name') || '字段名称'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_column_type') || '字段类型'"
            prop="inputColumnType"
          >
            <el-select
              v-model="formData.inputColumnType"
              :disabled="disabled"
              :placeholder="$l('form_label_column_type') || '字段类型'"
              size="medium"
              style="width: 100%"
              filterable
            >
              <el-option label="文字" value="input" />
              <el-option label="下拉框" value="select" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_is_multiselect') || '是否可多选'"
            prop="isMultiselect"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              :disabled="disabled"
              v-model="formData.isMultiselect"
            >
              <el-radio label="Y">{{ $l("form_radio_yes") || "是" }}</el-radio>
              <el-radio label="N">{{ $l("form_radio_no") || "否" }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_is_required') || '是否必输项'"
            prop="isRequired"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              :disabled="disabled"
              v-model="formData.isRequired"
            >
              <el-radio label="Y">{{ $l("form_radio_yes") || "是" }}</el-radio>
              <el-radio label="N">{{ $l("form_radio_no") || "否" }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_attribute_type') || '属性类型'"
            prop="inputColumnName"
            required
          >
            <dict-select
              v-if="formData.inputColumnType === 'select'"
              v-model="formData.inputColumnName"
              :disabled="disabled"
              filterable
              clearable
              url="/digitalCenter/common/dict/elementDictionarySelect"
              size="medium"
              :placeholder="$l('form_label_attribute_type') || '属性类型'"
              style="width: 100%"
            ></dict-select>
            <el-input
              v-else-if="formData.inputColumnType === 'input'"
              v-model="formData.inputColumnName"
              maxlength="50"
              :disabled="disabled"
              clearable
              size="medium"
              :placeholder="$l('form_label_attribute_type') || '属性类型'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_sortorder') || '排序顺序'"
            prop="sortOrder"
          >
            <el-input
              v-model="formData.sortOrder"
              disabled
              clearable
              size="medium"
              :placeholder="$l('form_label_sortorder') || '排序顺序'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="4"></el-col>
        <el-col v-if="createDateVisible">
          <div style="font-size: 14px; color: #606266">
            <span
              >Create：{{ formData.createByName }} at
              {{ formData.createDate }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span
              >Modify：{{ formData.modifyByName }} at
              {{ formData.modifyDate }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    createDateVisible: Boolean,
    templateCode: String,
    deCategoryCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        isVisible: "Y",
        deCategoryCode: this.deCategoryCode,
        inputColumnType: "select",
      },
      rules: {
        deCategoryCode: [
          {
            required: true,
            message: this.$l("form_rule_message_category") || "请选择分类",
            trigger: "change",
          },
        ],
        inputColumnDisplay: [
          {
            required: true,
            message:
              this.$l("form_rule_message_column_name") || "请输入字段名称",
            trigger: "blur",
          },
          {
            max: 50,
            message:
              this.$l("form_rule_input_length_50") || "长度在50个字符以内",
            trigger: "blur",
          },
        ],
        inputColumnType: [
          {
            required: true,
            message:
              this.$l("form_rule_message_column_type") || "请选择字段类型",
            trigger: "change",
          },
        ],
        isVisible: [
          {
            required: true,
            message:
              this.$l("form_rule_message_visible_status") || "请选择是否显示",
            trigger: "change",
          },
        ],
        inputColumnName: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_type") || "属性类型不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.templateCode) return;

      this.$api
        .detailDesignElementsInputTemplateApi({
          templateCode: this.templateCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) {
        return;
      }
      this.loadingOpen();
      this.$api
        .saveDesignElementsInputTemplateApi(this.formData)
        .then((res) => {
          this.loadingClose();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.openQuestion();
    },
    close() {
      this.$emit("close");
    },
    openQuestion() {
      this.$confirm(
        this.$l("INDEX.tips_question_save") || "是否要保存更改",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l("INDEX.btn_save") || "保存",
          cancelButtonText: this.$l("INDEX.btn_no_save") || "不保存",
        }
      )
        .then(() => {
          this.save();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.close();
          }
        });
    },
  },
};
</script>
